import { unloadedAsyncState } from "widgets-for-react";
import { features } from "../../features";
import { getMainDomain } from "../../utils/browser";
import { deleteCookie } from "../../utils/cookies";
export const gtCallBackName = 'googleTranslateElementInit';
export const initialGoogleTranslateState = {
    googleTranslate: {
        dropdown: unloadedAsyncState()
    }
};
export const gtTargetElementId = 'google_translate_element';
export const loadGoogleTranslate = ()=>{
    const scriptId = 'google_translate_script';
    if (document.getElementById(scriptId)) return;
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `//translate.google.com/translate_a/element.js?cb=${gtCallBackName}`;
    script.async = true;
    document.body.appendChild(script);
};
export const buildGoogleTranslateElement = ()=>{
    const feature = features().automatedTranslations;
    const push = feature != 'off' && feature.pushDataLayerEvent;
    new window.google.translate.TranslateElement({
        autoDisplay: false
    }, gtTargetElementId);
    const dropdown = document.querySelector('#\\:0\\.targetLanguage select');
    dropdown.classList.add('notranslate');
    dropdown.id = 'google_language_selector';
    dropdown.addEventListener('change', function() {
        push(dropdown.value);
        if (dropdown.value == "nl" || dropdown.value == "") {
            // Google Translate writes a cookie for both the current subdomain and the main domain.
            // We need to delete both to fully reset the translation.
            deleteCookie("googtrans");
            deleteCookie("googtrans", getMainDomain());
            window.location.reload();
        }
    });
    return dropdown;
};
